import { Logger } from '@terros/common'

const logger = new Logger('token/manager')
// logger.level = 'verbose'

export class TokenManager {
  private inFlight: Promise<string | undefined> | undefined = undefined

  async getToken(getFn: () => Promise<string | undefined>): Promise<string | undefined> {
    try {
      if (this.inFlight) {
        logger.verbose('Token fetch already in flight, awaiting existing promise')
        return this.inFlight
      }

      logger.verbose('No token fetch in flight, initiating new fetch')

      this.inFlight = getFn()
      const token = await this.inFlight
      this.inFlight = undefined
      return token
    } catch (error) {
      logger.warn('Error fetching token, resetting inFlight state')
      this.inFlight = undefined
    }
  }
}
